var service = {};

if (process.env.NODE_ENV === 'production') {
    service.API_URL = 'https://vm-api.eduwity.com';
} else {
    service.API_URL = 'http://192.168.1.66:5002';
}

export default service;
